import Api from 'common/middleware/api';

export const REPORT_PREVIEW_ERROR = 'REPORT_PREVIEW_ERROR';
export const reportPreviewError = (error, params) => ({
  error,
  params,
  type: REPORT_PREVIEW_ERROR,
});

export const REPORT_PREVIEW_REQUEST = 'REPORT_PREVIEW_REQUEST';
export const reportPreviewRequest = (params) => ({
  params,
  type: REPORT_PREVIEW_REQUEST,
});

export const REPORT_PREVIEW_SUCCESS = 'REPORT_PREVIEW_SUCCESS';
export const reportPreviewSuccess = (html, params) => ({
  html,
  params,
  type: REPORT_PREVIEW_SUCCESS,
});

export const fetchReportPreviewAction = (params, reportType) => (dispatch) => {
  dispatch(reportPreviewRequest(params));
  return Api.fetchReportPreview(params, reportType)
    .then(Api.checkStatus)
    .then((response) => response.text())
    .then((html) => dispatch(reportPreviewSuccess(html, params)))
    .catch((error) => dispatch(reportPreviewError(error, params)));
};
